import React, { useState } from 'react';

const CommitteeMemberCard = ({ title, name, faculty, photoUrl, intro }) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasIntro = Boolean(intro);

    const handleToggle = () => {
        if (!hasIntro) return;
        setIsOpen((prev) => !prev);
    };

    return (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
            <button
                type="button"
                onClick={handleToggle}
                className={`w-full text-left p-5 flex items-start ${photoUrl ? 'gap-4' : ''} ${hasIntro ? 'cursor-pointer' : 'cursor-default'}`}
            >
                {photoUrl && (
                    <div className="flex-shrink-0">
                        <img
                            src={photoUrl}
                            alt={name || title}
                            className="w-20 h-20 rounded-full object-cover object-center border border-gray-200 shadow-sm"
                            style={{ objectFit: 'cover', objectPosition: 'center' }}
                        />
                    </div>
                )}
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-blue-600 uppercase tracking-wide break-words">{title}</p>
                    {name && <p className="mt-1 text-base font-semibold text-gray-900 break-words">{name}</p>}
                    {faculty && <p className="mt-0.5 text-sm text-gray-600 break-words">{faculty}</p>}
                </div>
                {hasIntro && (
                    <div className="ml-2 flex-shrink-0 text-gray-400">
                        <svg
                            className={`w-5 h-5 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                )}
            </button>
            {hasIntro && isOpen && (
                <div className="px-5 pb-5 pt-0">
                    <p className="text-sm text-gray-700 leading-relaxed text-justify">{intro}</p>
                </div>
            )}
        </div>
    );
};

export default CommitteeMemberCard;

